// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Hs-z","outfitFeedbackSection":"Is-z"};